export const DEFAULT_SCRIPT_MODE = 'creative';

export const SCRIPT_MODE_OPTIONS = [
  {
    value: 'creative',
    label: 'Creative',
    description: 'More expressive, stylized scripting.',
  },
  {
    value: 'grounded',
    label: 'Grounded',
    description: 'More literal, product-focused scripting.',
  },
    {
    value: 'director_native',
    label: 'Director Native',
    description: '',
  },
];

export const normalizeScriptMode = (value) =>
  SCRIPT_MODE_OPTIONS.some((option) => option.value === value) ? value : DEFAULT_SCRIPT_MODE;
